import { PhaseService } from "./PhaseService";

export type { IPhaseService } from "./IPhaseService";

export const phaseService = new PhaseService();
